import { QuestionRadiogroupModel } from 'survey-core'
import { DeleteFile } from '../../../../../services/FileService'
import { type RadioMatrix, type MappedChoice } from './types'

export const CUSTOM_TYPE = 'surveyradio'

export class SurveyRadio extends QuestionRadiogroupModel {
  constructor (name: string) {
    super(name)
    this.titleLocation = 'hidden'
  }

  getType (): string {
    return CUSTOM_TYPE
  }

  get radioMatrix (): RadioMatrix {
    return this.getPropertyValue('radioMatrix')
  }

  set radioMatrix (val: RadioMatrix) {
    this.setPropertyValue('radioMatrix', val)
  }

  get extraInfo (): string {
    return this.getPropertyValue('extraInfo')
  }

  set extraInfo (val: string) {
    this.setPropertyValue('extraInfo', val)
  }

  get uploadedFileName (): string {
    return this.getPropertyValue('uploadedFileName')
  }

  set uploadedFileName (val: string | null) {
    this.setPropertyValue('uploadedFileName', val)
  }

  get uploadedFileKey (): string {
    return this.getPropertyValue('uploadedFileKey')
  }

  set uploadedFileKey (val: string | null) {
    this.setPropertyValue('uploadedFileKey', val)
  }

  get mappedChoices (): MappedChoice[] {
    return this.choices.map((choice) => {
      const choiceValue = choice.value as string
      const matrixItem = this.radioMatrix?.[choiceValue]
      return {
        value: choiceValue,
        text: choice.text as string,
        hasTextArea: matrixItem?.hasTextInput ?? false,
        infoText: matrixItem?.infoText ?? '',
        hasUpload: matrixItem?.hasUpload ?? false,
        uploadHTML: matrixItem?.uploadHTML ?? ''
      }
    })
  }

  isEmpty (): boolean {
    const baseEmpty = super.isEmpty()
    if (baseEmpty) return true

    if (this.value != null) {
      const selectedChoice = this.mappedChoices.find(c => c.value === this.value)
      if (selectedChoice?.hasTextArea === true) {
        return this.extraInfo == null || this.extraInfo.trim() === ''
      }

      if (selectedChoice?.hasUpload === true) {
        return this.uploadedFileKey == null || this.uploadedFileKey.trim() === ''
      }
    }

    return false
  }

  async deleteFile (): Promise<void> {
    const key = this.uploadedFileKey
    if (key != null && key !== '') {
      try {
        await DeleteFile(key)
      } catch (e) {
        console.error('Failed to delete file from server', e)
      }
    }
    this.uploadedFileName = null
    this.uploadedFileKey = null
  }

  handleFileSelect (file: File | undefined): void {
    if (file !== undefined) {
      this.survey.uploadFiles(this, file.name, [file], (data: any, errors: any) => {
        if (errors != null && errors.length > 0) {
          console.error('File upload errors:', errors)
        }
      })
    }
  }
}
